import { combineReducers } from "redux"
import invitesReducer from "./invitesReducer"
import inviteUiReducer from "./inviteUIReducer"

export default combineReducers({
  invites: invitesReducer,
  ui: inviteUiReducer,
})
